import React, { Fragment } from "react"
import { Container, Row, Col } from 'react-bootstrap';
import GuideDetailsLink from './GuideDetailsLink';
// import Agent01 from "../../images/static/agent.png"


// import Img01 from "../../images/guide/history_m.jpg";
// import Img02 from "../../images/guide/history_t.jpg";
// import Img03 from "../../images/guide/history_d.jpg";

// import OutDoorMImg01 from "../../images/guide/outdoor_m01.jpg";
// import OutDoorTImg01 from "../../images/guide/outdoor_t01.jpg";
// import OutDoorDImg01 from "../../images/guide/outdoor_d01.jpg";

// import OutDoorMImg02 from "../../images/guide/outdoor_m02.jpg";
// import OutDoorTImg02 from "../../images/guide/outdoor_t02.jpg";
// import OutDoorDImg02 from "../../images/guide/outdoor_d02.jpg";

// import Sidebar from "../Sidebar/Sidebar";
// import { GetURL } from "../Common/site/functions"
// Style
import './GuideDetails.scss';
import HTMLReactParser from "html-react-parser";
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    // InstapaperShareButton,
} from "react-share";

// import {
//     InstapaperIcon
// } from "react-share";
import TeamSpeak from "./TeamSpeak";

import { inViewOptions, fadeInFromTop } from '../Utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const GuideDetails = (props) => {
    const modules = props.data ? props.data.Modules_Area_Guides : [];
    const shareurl = typeof window !== 'undefined' ? window.location.href : ''

    const trackerShare = (event, scl_share_url) => {
        var shareURL = typeof window !== 'undefined' ? window.location.href : ''
        if (scl_share_url) {
            window.open(scl_share_url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600')
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'Share - social icons',
            'formType': event + ' - ' + shareURL,
            'formId': 'Share',
            'formName': 'Share',
            'formLabel': 'Share', 
            'formPage' : shareURL
        });
    }
    return (
        <>
            <section className="guide-details">
                <Container>
                    <Row>
                        <Col xl={8} lg={7}>
                            {modules.filter(c => typeof c.Intro_Content !== "undefined").map((each, i) =>
                                <InView {...inViewOptions}>
                                    {({ ref, inView }) => (
                                        <motion.div
                                            className="guide-info"
                                            ref={ref}
                                            initial="hidden"
                                            animate={inView ? "visible" : "hidden"}
                                            variants={fadeInFromTop}
                                        >
                                            <span className="sm-text">
                                                {each.Intro_Title}
                                            </span>
                                            {each.Intro_Content &&
                                                HTMLReactParser(each.Intro_Content.replace(/<br\s*\/?>/gi, ''))
                                            }
                                        </motion.div>
                                    )}
                                </InView>
                            )}

                            {modules.map((module, i) =>
                                <Fragment key={i}>
                                    {(module.Content && module.Title) &&
                                        <InView {...inViewOptions}>
                                            {({ ref, inView }) => (
                                                <motion.div
                                                    className="paragraph"
                                                    ref={ref}
                                                    initial="hidden"
                                                    animate={inView ? "visible" : "hidden"}
                                                    variants={fadeInFromTop}
                                                >
                                                    <div className="history outdoors">
                                                        <h2>{module.Title}</h2>
                                                        {module.Content &&
                                                            HTMLReactParser(module.Content.replace(/<br\s*\/?>/gi, ''))
                                                        }
                                                        {(module.Images?.length === 1) &&
                                                            <div className="history-img img-zoom">
                                                                <picture>
                                                                    <source media="(min-width:992px)" srcSet={module.Images[0].url} />
                                                                    <source media="(min-width:768px)" srcSet={module.Images[0].url} />
                                                                    <img src={module.Images[0].url} alt={module.Images[0].alternativeText} />
                                                                </picture>
                                                            </div>
                                                        }
                                                        {(module.Images?.length === 2) &&
                                                            <div className="outdoor-wrapper">
                                                                {module.Images.map((img, k) =>
                                                                    <div className="outdoor-img img-zoom" key={k}>
                                                                        <picture>
                                                                            <source media="(min-width:992px)" srcSet={img.url} alt={img.alternativeText}  />
                                                                            <source media="(min-width:768px)" srcSet={img.url} alt={img.alternativeText} />
                                                                            <img src={img.url} alt="client-Img" />
                                                                        </picture>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        }
                                                    </div>
                                                </motion.div>
                                            )}
                                        </InView>
                                    }

                                    {(module.CTA_Label && module.Description && module.Blk_Title) &&
                                        <InView {...inViewOptions}>
                                            {({ ref, inView }) => (
                                                <motion.div
                                                    className="buy-sell"
                                                    ref={ref}
                                                    initial="hidden"
                                                    animate={inView ? "visible" : "hidden"}
                                                    variants={fadeInFromTop}
                                                >
                                                    <div className="info">
                                                        <h2>{module.Blk_Title}</h2>
                                                        <p>{module.Description}</p>
                                                    </div>
                                                    <div className="buy-btn">
                                                        {
                                                            module.CTA_Link.id &&
                                                            <GuideDetailsLink module={module} />
                                                        } 

                                                    </div>
                                                </motion.div>
                                            )}
                                        </InView>
                                    }
                                </Fragment>
                            )}

                            <InView {...inViewOptions}>
                                {({ ref, inView }) => (
                                    <motion.div
                                        className="social-links"
                                        ref={ref}
                                        initial="hidden"
                                        animate={inView ? "visible" : "hidden"}
                                        variants={fadeInFromTop}
                                    >
                                        <span className="sm-txt">Share this article:</span>
                                        <span className="social-site">
                                            <TwitterShareButton onClick={() => trackerShare('TwitterShareButton')} url={shareurl} className="my-share-button twitter-share">
                                                <i className="icon-twitter"></i>
                                            </TwitterShareButton>

                                            <FacebookShareButton onClick={() => trackerShare('FacebookShareButton')} url={shareurl} className="my-share-button facebook-share">
                                                <i className="icon-fb"></i>
                                            </FacebookShareButton>

                                            <LinkedinShareButton onClick={() => trackerShare('LinkedinShareButton')} url={shareurl} className="my-share-button linkedin-share">
                                                <i className="icon-linkedln"></i>
                                            </LinkedinShareButton>

                                            <a href={`javascript:;`} onClick={() => trackerShare('GplusShareButton', 'https://plus.google.com/share?url=' + shareurl)}>
                                                <i className="icon-google"></i>
                                            </a>

                                            <a href={`javascript:;`} onClick={() => trackerShare('InstaShareButton', 'https://www.instagram.com/?url=' + shareurl)}>
                                                <i className="icon-insta"></i>
                                            </a>

                                        </span>
                                    </motion.div>
                                )}
                            </InView>
                        </Col>
                        {(props.data?.Speak_with_teams && props.data?.Speak_with_teams.length > 0) && <Col xl={4} lg={5}>
                            <InView {...inViewOptions}>
                                {({ ref, inView }) => (
                                    <motion.div
                                        className="block-sticky"
                                        ref={ref}
                                        initial="hidden"
                                        animate={inView ? "visible" : "hidden"}
                                        variants={fadeInFromTop}
                                    >
                                        <TeamSpeak type="area_guide" data={props.data.Speak_with_teams} area={props.data.Title} area_url={props.data.URL} />
                                    </motion.div>
                                )}
                            </InView>
                        </Col>}
                    </Row>
                </Container>
            </section>
            {/* {modules.map((each, i) => 
                    <Fragment key={i}>
                        {(each.Intro_Title && each.Intro_Content) &&
                            <AboutSection {...each} />
                        }
                    </Fragment>
                )} */}
        </>
    )
}
export default GuideDetails;